















































import { Component, Vue ,Watch} from "vue-property-decorator";
import { StoreState } from "../../store";
import { mapState } from "vuex";
import VueElementLoading from "vue-element-loading";
import { RotateSquare2 } from "vue-loading-spinner";
import util from '../../lib/util';

@Component({
  components: { VueElementLoading, RotateSquare2 },
  
  computed: {
    ...mapState({
      admin_loader: (state: StoreState) => state.dashboard.admin.admin_loader,
      conferenceMainData:  (state: StoreState) => state.dashboard.ConferenceData
    })
  },
  methods: {
    // isNumber: function(evt) {
    //   evt = evt ? evt : window.event;
    //   var charCode = evt.which ? evt.which : evt.keyCode;
    //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    //     evt.preventDefault();
    //   } else {
    //     return true;
    //   }
    // }
  },
  mounted(){
    this.$store.dispatch("getConferencedata");
  }
})
export default class Panel extends Vue {
  data() {
    return {
      calendarImg: 'img/icons/conference_icons/calendar.png',
      phoneImg: 'img/icons/conference_icons/phone.png',
      pinValue: "",
        conferencedata: {member:{pins:[''],join_muted:false,join_deaf:false},conference_numbers:['']},
      conference_call_in_number: "",
      checkboxVal: {
        muted: false,
        deaf: false,
        entry: false,
        exit: true
      }
    };
  }


    @Watch('conferenceMainData')
        SetConferencedata() {
            this.$data.conferencedata= (this as any).conferenceMainData;
            
        }

         isNumber(event, message) {
            if (!/\d/.test(event.key) &&  
                (event.key !== "." || /\./.test(message))     
            )  
                return event.preventDefault();  
            }

  async created() {
   this.$store.commit("SET_ADMIN_LOADER", true);
   /*await this.$store.dispatch("getConferencedata").then(r => {
      this.$data.conferencedata = r.data.data;      
    });*/
     this.$store.dispatch("getCallflows").then(r => {
     //this.$store.commit("SET_ADMIN_LOADER", false);
      this.$data.conference_call_in_number = util.formatPhoneNumber(
        r.data.data[0].numbers[0]
      );
    });
  }

  formatPhoneNumber(phoneNumber: any) {
    if (typeof phoneNumber === "number") {
      phoneNumber = phoneNumber.toString();
    }
    //This regex is based off the format of phone numbers
    //as they are returned in the contact list by the Kazoo API.
    //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
    //If the Hellospoke database uses a different format will adjust
    //the pattern accordingly
    const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
    const matches = phoneNumber.match(re);
    if (matches === null) {
      console.log("The phone number " + phoneNumber + " could not be parsed");
      return "Invalid number";
    }
    return `+1 ${matches[1]} ${matches[2]} ${matches[3]}`;
  }

  async save() { 
    this.$store.commit("SET_ADMIN_LOADER", true);
    const moderatorpin =
      (this as any).conferencedata.moderator.pins.length > 0
        ? (this as any).conferencedata.moderator.pins[0]
        : "";
    const memberpin =
      (this as any).conferencedata.member.pins.length > 0
        ? (this as any).conferencedata.member.pins[0]
        : "";
    var payload = {
      join_muted: (this as any).conferencedata.member.join_muted,
      join_deaf: (this as any).conferencedata.member.join_deaf,
      play_entry_tone: (this as any).conferencedata.play_entry_tone,
      play_exit_tone: (this as any).conferencedata.play_exit_tone,
      moderatorpin: moderatorpin,
      memberpin: memberpin,
      id: (this as any).conferencedata.id
    };
    await this.$store.dispatch("updateconference", payload).then(r => {
    this.$store.commit("SET_ADMIN_LOADER", false);
      
    });
  }
}
